"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _Editor = _interopRequireDefault(require("./Editor"));
var _Waveform = _interopRequireDefault(require("./Waveform"));
var _Controls = _interopRequireDefault(require("./Controls"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var colors = ['#FF0000', '#00FF00', '#0000FF', '#990000', '#009900', '#000099', '#330000', '#003300', '#000033'];

/** React component to edit word timings */
var TimingEditor = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(TimingEditor, _React$Component);
  function TimingEditor(props) {
    var _this;
    _classCallCheck(this, TimingEditor);
    _this = _callSuper(this, TimingEditor, [props]);
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var request = new XMLHttpRequest();
      request.open('GET', _this.props.audioFile, true);
      request.responseType = 'blob';
      request.addEventListener('load', function () {
        var context = new (window.AudioContext || window.webkitAudioContext)();
        var fileReader = new FileReader();
        fileReader.onload = function (e) {
          var arrayBuffer = e.target.result;
          context.decodeAudioData(arrayBuffer, function (buffer) {
            var channelData = buffer.getChannelData(0);
            _this.setState({
              channelData: channelData,
              step: Math.ceil(channelData.length / _this.state.width)
            });
          });
        };
        context.close();
        fileReader.readAsArrayBuffer(request.response);
        var audio = new Audio(window.URL.createObjectURL(request.response));
        audio.addEventListener('ended', function () {
          _this.setState({
            playing: false
          });
        });
        audio.addEventListener('pause', function () {
          _this.setState({
            playing: false
          });
        });
        audio.addEventListener('play', function () {
          _this.setState({
            playing: true
          });
        });
        _this.setState({
          audio: audio
        });
      });
      request.send();
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      clearInterval(_this.timingInterval);
      _this.timingInterval = null;
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      var _this$state = _this.state,
        selection = _this$state.selection,
        audio = _this$state.audio,
        update = _this$state.update;
      if (selection) {
        if (!audio.paused && audio.currentTime + update / 1000 >= selection.end / 1000) {
          audio.pause();
          if (selection) {
            audio.currentTime = selection.start / 1000;
          } else {
            audio.currentTime = 0;
          }
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "save", function () {
      var result = _this.state.timings.map(function (timing) {
        return (0, _pick2["default"])(timing, ['word', 'start', 'end']);
      });
      _this.props.save(result);
      return result;
    });
    _defineProperty(_assertThisInitialized(_this), "wordSelected", function (i, e) {
      _this.state.audio.currentTime = _this.state.timings[i].start / 1000;
      _this.state.audio.play();
      _this.setState({
        selection: _this.state.timings[i]
      });
    });
    _defineProperty(_assertThisInitialized(_this), "changeTiming", function (i, prop, e) {
      var t = (0, _cloneDeep2["default"])(_this.state.timings);
      t[i][prop] = +e.target.value;
      _this.setState({
        timings: t
      }, _this.updateTimings);
    });
    _defineProperty(_assertThisInitialized(_this), "updateTimings", function () {
      _this.props.onTimingChange(_this.state.timings);
    });
    _defineProperty(_assertThisInitialized(_this), "play", function () {
      if (!_this.state.audio.paused) {
        _this.state.audio.pause();
      } else {
        if (_this.state.selection) {
          _this.state.audio.currentTime = _this.state.selection.start / 1000;
        }
        _this.state.audio.play();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "goTo", function (time) {
      _this.state.audio.currentTime = time;
    });
    _defineProperty(_assertThisInitialized(_this), "goToStart", function () {
      _this.goTo(0);
    });
    _defineProperty(_assertThisInitialized(_this), "goBack", function () {
      _this.goTo(_this.state.audio.currentTime - _this.props.skip);
    });
    _defineProperty(_assertThisInitialized(_this), "goForward", function () {
      _this.goTo(_this.state.audio.currentTime + _this.props.skip);
    });
    _defineProperty(_assertThisInitialized(_this), "goEnd", function () {
      _this.goTo(_this.props.duration ? _this.props.duration / 1000 : _this.state.audio.duration);
    });
    _defineProperty(_assertThisInitialized(_this), "deselect", function () {
      _this.setState({
        selection: null
      });
    });
    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      _this.setState({
        timings: (0, _cloneDeep2["default"])(_this.origtimings)
      });
    });
    _defineProperty(_assertThisInitialized(_this), "zoomIn", function () {
      _this.setState({
        width: _this.state.width + _this.props.zoomFactor
      });
    });
    _defineProperty(_assertThisInitialized(_this), "zoomOut", function () {
      _this.setState({
        width: Math.max(_this.state.width - _this.props.zoomFactor, _this.props.zoomFactor)
      });
    });
    var timings = _this.props.timings.map(function (timing, index) {
      return _objectSpread({
        color: colors[index % colors.length]
      }, timing);
    });
    _this.origtimings = (0, _cloneDeep2["default"])(timings);
    _this.state = {
      timings: timings,
      width: 800,
      height: 100,
      playing: false,
      audio: null,
      selection: null,
      step: null,
      channelData: null,
      currentTime: 0
    };
    _this.timingInterval = setInterval(function () {
      _this.setState({
        currentTime: _this.state.audio ? _this.state.audio.currentTime : 0
      });
    }, props.update);
    return _this;
  }
  _createClass(TimingEditor, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: '.5em'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Controls["default"], {
        goToStart: this.goToStart,
        goBack: this.goBack,
        play: this.play,
        goForward: this.goForward,
        goEnd: this.goEnd,
        reset: this.reset,
        save: this.save,
        playing: this.state.playing,
        zoomIn: this.zoomIn,
        zoomOut: this.zoomOut,
        showSave: this.props.showSave,
        generateTimings: this.props.generateTimings,
        removeTimings: this.props.removeTimings,
        onSubmit: this.props.onSubmit
      })), /*#__PURE__*/_react["default"].createElement("strong", null, "Current time: ", Math.floor(this.state.currentTime * 1000)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          overflowX: 'auto',
          overflowY: 'hidden'
        }
      }, /*#__PURE__*/_react["default"].createElement(_Waveform["default"], {
        audio: this.state.audio,
        timings: this.state.timings,
        selection: this.state.selection,
        width: this.state.width,
        height: this.state.height,
        color: this.props.color,
        step: this.state.step,
        channelData: this.state.channelData,
        duration: this.props.duration,
        update: this.props.update,
        play: this.play,
        onTimingChange: this.updateTimings
      })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Editor["default"], {
        deselect: this.deselect,
        timings: this.state.timings,
        wordSelected: this.wordSelected,
        changeTiming: this.changeTiming,
        color: this.props.color,
        currentTime: this.state.currentTime
      })));
    }
  }]);
  return TimingEditor;
}(_react["default"].Component);
_defineProperty(TimingEditor, "propTypes", {
  /** The url for the audio file to be used when editing */
  audioFile: _propTypes["default"].string.isRequired,
  /** The timings array that corresponds with the audio */
  timings: _propTypes["default"].array.isRequired,
  /** Callback function to use when the save button is pressed on the toolbar. Paramater passed to callback will be the updated html string */
  save: _propTypes["default"].func,
  onTimingChange: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func,
  /** Time in seconds to skip when using fast forward and rewind on the toolbar */
  skip: _propTypes["default"].number,
  /** Length of the audio in milliseconds */
  duration: _propTypes["default"].number,
  /** Color to use for the waveform and timing bar */
  color: _propTypes["default"].string,
  /** Update interval for the canvas. Smaller numbers make smoother outputs, but can cause lag if there are many editors on the screen at once. 21 ~= 60 fps */
  update: _propTypes["default"].number,
  zoomFactor: _propTypes["default"].number,
  showSave: _propTypes["default"].bool,
  generateTimings: _propTypes["default"].func,
  removeTimings: _propTypes["default"].func
});
_defineProperty(TimingEditor, "defaultProps", {
  save: function save() {},
  onTimingChange: function onTimingChange() {},
  color: 'black',
  skip: 1,
  update: 21,
  zoomFactor: 200
});